// import moment from "moment";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { edit_icon, view_icon } from "../../assets/img";
// import { Table } from "../../components/Table/Table";

// function WalletRejectedList({
//   ownersList,
//   pagination,
//   setIsUpdate,
//   reSend,
//   setIsRejectList,
//   isRejectList,
// }) {
//   const [page, setPage] = useState(1);
//   const navigate = useNavigate();
//   // Tickect ID : {?.data}
//   const [owners, setOwners] = useState(ownersList);

//   const columns = React.useMemo(
//     () => [
//       {
//         Header: "S.No",
//         accessor: "",
//         Cell: ({ value, row }) => {
//           return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
//         },
//       },
//       {
//         Header: "Created By",
//         accessor: "requested_name",

//         Cell: ({ value, row }) => {
//           console.log("jfkakljdslkaklsfjaslk", value);

//           return (
//             <>
//               <p>{value || row?.original.requested_by}</p>
//               <p>
//                 {moment(row?.original?.created_at).format("DD/MM/YYYY") || "-"}
//               </p>
//             </>
//           );
//         },
//       },
//       {
//         Header: "Rejected By",
//         accessor: "processed_name",
//         Cell: ({ value, row }) => {
//           return (
//             <>
//               <p>{value}</p>
//               <p>
//                 {" "}
//                 {moment(row?.original?.updated_at).format("DD/MM/YYYY") || "-"}
//               </p>
//             </>
//           );
//         },
//       },
//       {
//         Header: "Amount",
//         accessor: "admin_transaction_amount",
//         Cell: ({ value, row }) => {
//           return <p>{value}</p>;
//         },
//       },
//       {
//         Header: "Super Admin",
//         accessor: "reason",
//         Cell: ({ value, row }) => {
//           return (
//             <p
//               //   className="text-nowrap"
//               style={{
//                 display: "-webkit-box",
//                 WebkitLineClamp: 2,
//                 WebkitBoxOrient: "vertical",
//                 overflow: "hidden",
//                 whiteSpace: "normal",
//                 // width: "400px",
//               }}
//             >
//               {value}
//             </p>
//           );
//         },
//       },

//       {
//         Header: "Admin",
//         accessor: "description",
//         Cell: ({ value, row }) => {
//           return (
//             <p //   className="text-nowrap"
//               style={{
//                 display: "-webkit-box",
//                 WebkitLineClamp: 2,
//                 WebkitBoxOrient: "vertical",
//                 overflow: "hidden",
//                 whiteSpace: "normal",
//                 maxWidth: "300px",
//                 // width: "400px",
//               }}
//             >
//               {value}
//             </p>
//           );
//         },
//       },
//     ],
//     [page]
//   );
//   useEffect(() => {
//     setOwners(ownersList);
//   }, [ownersList]);
//   console.log("ownersList-isRejectList", ownersList);

//   return (
//     <>
//       <div
//         style={{
//           background: "#FFFFFF",
//           boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
//           borderRadius: "10px",
//           padding: 10,
//           width: "295px",
//           flexDirection: "row",
//           justifyContent: "center",
//           alignItems: "center",
//           marginTop: 10,
//         }}
//       >
//         <h2
//           style={{
//             fontFamily: "Open Sans",
//             fontStyle: "normal",
//             fontWeight: 400,
//             fontSize: "18px",
//             lineHeight: "25px",
//             textAlign: "center",
//             /* identical to box height */

//             color: "#222227",
//           }}
//         >
//           Tickect ID : {isRejectList?.ticket_id?.ticket_transaction?.ticket}
//         </h2>
//       </div>
//       <Table
//         columns={columns}
//         setPageno={setPage}
//         pagecount={pagination}
//         data={owners}
//         show={true}
//       />
//     </>
//   );
// }

// export default WalletRejectedList;
import moment from "moment";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { edit_icon, view_icon } from "../../assets/img";
import { Table } from "../../components/Table/Table";

const WalletRejectedList = React.memo(
  ({
    ownersList,
    pagination,
    setIsUpdate,
    reSend,
    setIsRejectList,
    isRejectList,
    // setPagination,
    setPage,
    page,
  }) => {
    // const [page, setPage] = useState(1);
    const navigate = useNavigate();
    const [owners, setOwners] = useState(ownersList);

    // Memoize columns to prevent recreation on every render
    const columns = useMemo(
      () => [
        {
          Header: "S.No",
          accessor: "",
          Cell: ({ value, row }) => {
            return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
          },
        },
        {
          Header: "Created By",
          accessor: "requested_name",
          Cell: ({ value, row }) => {
            return (
              <>
                <p>{value || row?.original.requested_by}</p>
                <p>
                  {moment(row?.original?.created_at).format("DD/MM/YYYY") ||
                    "-"}
                </p>
              </>
            );
          },
        },
        {
          Header: "Rejected By",
          accessor: "processed_name",
          Cell: ({ value, row }) => {
            return (
              <>
                <p>{value}</p>
                <p>
                  {moment(row?.original?.updated_at).format("DD/MM/YYYY") ||
                    "-"}
                </p>
              </>
            );
          },
        },
        {
          Header: "Amount",
          accessor: "admin_transaction_amount",
          Cell: ({ value, row }) => {
            return <p>{value}</p>;
          },
        },
        {
          Header: "Super Admin",
          accessor: "reason",
          Cell: ({ value, row }) => {
            return (
              <p
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  whiteSpace: "normal",
                }}
              >
                {value}
              </p>
            );
          },
        },
        {
          Header: "Admin",
          accessor: "description",
          Cell: ({ value, row }) => {
            return (
              <p
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  whiteSpace: "normal",
                  maxWidth: "300px",
                }}
              >
                {value}
              </p>
            );
          },
        },
      ],
      [page]
    );

    // Update owners when ownersList changes
    useEffect(() => {
      setOwners(ownersList);
    }, [ownersList]);

    // Memoize ticket ID to prevent unnecessary recalculations
    const ticketId = useMemo(
      () => isRejectList?.ticket_id?.ticket_transaction?.ticket,
      [isRejectList]
    );

    // Memoize header styles
    const headerContainerStyle = useMemo(
      () => ({
        background: "#FFFFFF",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        padding: 10,
        width: "295px",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 10,
      }),
      []
    );

    const headerTextStyle = useMemo(
      () => ({
        fontFamily: "Open Sans",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "18px",
        lineHeight: "25px",
        textAlign: "center",
        color: "#222227",
      }),
      []
    );

    // Memoize setPageno callback
    const handlePageChange = useCallback((newPage) => {
      setPage(newPage);
    }, []);

    return (
      <>
        <div style={headerContainerStyle}>
          <h2 style={headerTextStyle}>Ticket ID : {ticketId}</h2>
        </div>
        <Table
          columns={columns}
          setPageno={handlePageChange}
          pagecount={pagination}
          data={owners}
          show={true}
        />
      </>
    );
  }
);

WalletRejectedList.displayName = "WalletRejectedList";

export default WalletRejectedList;
